import React, { useEffect, useState } from 'react';
 
import { Button, Col, Form, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
// import './portfolio.css';
// import Sidebar from '../Home/Sidebar';
import { axiosOpen } from '../../api/axios';
import Loader from '../Loader/Loader';

 

const UpdateForm = ( ) => {
    let {id} = useParams();
    const [data, setData] = useState();
    const [portfolios, setPortfolios] = useState('');
    const [project, setProject] = useState('');
    const [techstack, setTechstack] = useState('');
 
    
    const { register } = useForm();
    useEffect(() => {
      // console.log(id,"hello ");
      const fetchCompanyData = async ( ) => {
         
        try {
          
          const response = await axiosOpen.get("api/techstack/get/"+id);
          // const responsedata = await response.json();
          console.log(response);
          setData(response.data);
          setPortfolios(response.data.portfolio);
          setProject(response.data.projects);
          setTechstack(response.data.tech_stack);
        } catch (error) {
          console.error(error);
        }
      }
      fetchCompanyData();
    
    }, []);
    // console.log(portfolios);
    // console.log(data._id);
    // console.log(project);
    //   console.log(companyId);
    // console.log(id);
        let projects = project
        let portfolio =  portfolios
        const navigate = useNavigate();

      const handleSubmit = (event) => async () =>{
        // event.preventDefault();
          const body = JSON.stringify({ portfolio ,  projects  })
  
        const response = await axiosOpen.post("api/techstack/updateTechstack/"+id, body);
        // toast.success('Portfolio Updated Successfully');
          navigate('/portfolio') 
      };
  return (
     <>
     {/* <Toast /> */}
      <div className="row">
        <div className="col-3">
          {/* <Sidebar /> */}
        </div>
        <div className="col-9">
          <div className='article-title'>
              <Row>
              <div className="mb-3 mt-3">
                <h3 className="title"> {techstack}</h3>
              </div>
                  <Col md="9">
                      <Form onSubmit={handleSubmit}>
                          <Row>
                              <Col>
                                { data ?
                                  <>
                                    <Form.Group className="mb-4"   key={data._id} >
                                      <Form.Label className="portfolio-header bold-label">Portfolio URL</Form.Label>                                        
                                                                        
                                      <Form.Control 
                                      
                                        type="text"
                                        placeholder="Enter Portfolio URL"
                                        // rows={6}
                                        {...register("portfolio", { required: false })}
                                        value={portfolios}
                                        onChange={(e) => setPortfolios(e.target.value)}
                                      />
                                      <br/> 
                                        <Form.Label className="project-header bold-label">Portfolio Description</Form.Label>  
                                          
                                        <Form.Control 
                                        
                                        as="textarea"
                                        placeholder="Projects"
                                        rows={6}
                                        {...register("projects", { required: false })}
                                        value={project}
                                        onChange={(e) => setProject(e.target.value)}
                                      />
                                      <br/>   
                                      <div className='text-start'>
                                        <Button className='update-btn' onClick={handleSubmit()}>Update</Button> 
                                        </div>                                       
                                      </Form.Group>
                                    </>: <Loader />
                                    // <p>Loading ...</p>
                                            } 
                                    
                              </Col>
                          </Row>
                      </Form>
                  </Col>
              </Row>
          </div>
        </div>
        </div>
    </>
  )
}

export default UpdateForm
